import { switcher } from "./_switcher";

switcher();